import React from 'react';

/**
 * Material Symbols Outlined wrapper. Ported verbatim from
 * D:\campaigning-system\src\components\ui\Icon.tsx (types stripped).
 * Size/color come from className (font-size / text color). The font itself is
 * loaded route-scoped by useCampaignFonts; base rule lives in campaign-os.css.
 */
export function Icon({ name, className = '', filled = false, weight = 400, title }) {
  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={{ fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24` }}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      {name}
    </span>
  );
}

export default Icon;
